import { 
  BookOpen, 
  Scale, 
  Lightbulb, 
  BarChart3, 
  FileText, 
  Search,
  TrendingUp,
  MessageSquare
} from "lucide-react";
import { Insight } from "./types";

export const insightsData: Insight[] = [
  {
    id: 11,
    title: "The Economics of AI in Law",
    description: "If AI makes lawyers faster, how do firms keep billing? Explore value-based pricing, subscription models, and hybrid strategies replacing the billable hour.",
    color: "bg-emerald-600/20",
    url: "/insights/economics-of-ai-in-law",
    image: "/lovable-uploads/docketlabs-economics-of-ai-hero.png"
  },
  {
    id: 1,
    title: "How AVID LEGAL Positioned Itself as a Leader in Legal AI Adoption",
    description: "When a law firm recognizes the strategic importance of artificial intelligence—but lacks a unified plan—where should it begin?",
    // Icon removed
    color: "bg-sky-600/20",
    url: "https://www.linkedin.com/pulse/transforming-ai-curiosity-capability-how-avid-legal-positioned-cpxie/?trackingId=41%2BAkBgaTxzALe5OBlGGeA%3D%3D",
    image: "/lovable-uploads/optimized/transforming-ai-curiosity-800w.webp"
  },
  {
    id: 2,
    title: "3 Common Pitfalls Law Firms Make When Adopting AI",
    description: "AI is no longer optional for legal professionals—it's a priority. And yet, too many firms are still stumbling at the starting line. Here are three pitfalls we see again and again—and how to avoid them.",
    // Icon removed
    color: "bg-blue-600/20",
    url: "https://www.linkedin.com/pulse/3-common-pitfalls-law-firms-make-when-adopting-aiand-how-avoid-5z7wc/?trackingId=pt7uHwcKmze%2FOR2R2J4OcQ%3D%3D",
    image: "/lovable-uploads/optimized/ai-pitfalls-800w.webp"
  },
  {
    id: 3,
    title: "AI in the Legal Industry: Real-World Impact",
    description: "Case studies showing how firms of all sizes achieve measurable efficiency gains with AI adoption",
    icon: <BookOpen className="h-6 w-6" />,
    color: "bg-purple-600/20",
    url: "/insights/ai-adoption-in-legal-work-success-stories",
    image: "/lovable-uploads/a1489aeb-f602-439c-ac65-e6d32d44d137.png" 
  },
  {
    id: 4,
    title: "Generative AI is great for legal work — but make sure it's monitored",
    description: "Two magistrates say lawyers must understand how their AI tools work, supervise their teams, check results carefully",
    icon: <MessageSquare className="h-6 w-6" />,
    color: "bg-blue-600/20",
    url: "https://www.legaldive.com/news/generative-ai-is-great-for-legal-work-but-make-sure-its-monitored-judge/736198/"
  },
  {
    id: 5,
    title: "Most lawyers aren't using AI to address growing workloads",
    description: "A study finds that most legal professionals are not yet using AI to address increasing workload challenges",
    // Icon removed
    color: "bg-indigo-600/20",
    url: "https://www.abajournal.com/news/article/most-lawyers-arent-using-ai-to-address-growing-workloads-report-says",
    image: "/lovable-uploads/optimized/lawyer-workload-800w.webp"
  },
  {
    id: 6,
    title: "How to adopt GenAI within your legal department or law practice",
    description: "Capital spending and ROI will be top of mind for legal executives moving forward with AI legal tools in 2025",
    icon: <Scale className="h-6 w-6" />,
    color: "bg-cyan-600/20",
    url: "https://www.legaldive.com/news/how-to-adopt-genai-within-your-legal-department-or-law-practice/735008/"
  },
  {
    id: 7,
    title: "Using AI for Predictive Analytics in Litigation",
    description: "Learn how AI-powered predictive analytics can forecast litigation outcomes, guide strategy, and offer insights into judicial behavior",
    icon: <BarChart3 className="h-6 w-6" />,
    color: "bg-emerald-600/20",
    url: "https://www.americanbar.org/groups/senior_lawyers/resources/voice-of-experience/2024-october/using-ai-for-predictive-analytics-in-litigation/"
  },
  {
    id: 8,
    title: "Risk Or Revolution: Will AI Replace All Of Our Lawyers?",
    description: "As artificial intelligence reshapes many industries, the legal field faces its own crossroads",
    // Icon removed
    color: "bg-amber-600/20",
    url: "https://www.forbes.com/sites/hessiejones/2025/03/20/risk-or-revolution-will-ai-replace-lawyers/",
    image: "/lovable-uploads/optimized/ai-development-800w.webp"
  },
  {
    id: 9,
    title: "How AI is transforming the legal profession (2025)",
    description: "A survey of professionals reveals the impact of legal work, clients, concerns, and future roles",
    color: "bg-sky-600/20",
    url: "https://legal.thomsonreuters.com/blog/how-ai-is-transforming-the-legal-profession/",
    image: "/lovable-uploads/optimized/ai-legal-transform-800w.webp"
  },
  {
    id: 10,
    title: "2024 edition of the ABA's Legal Technology Survey Report",
    description: "ABA Tech Survey finds growing adoption of AI in legal practice, with efficiency gains as primary driver",
    color: "bg-blue-600/20",
    url: "https://www.lawnext.com/2025/03/aba-tech-survey-finds-growing-adoption-of-ai-in-legal-practice-with-efficiency-gains-as-primary-driver.html",
    image: "/lovable-uploads/optimized/aba-tech-survey-800w.webp"
  }
];
